import TYPES from '../actions/types';

const INITIAL_STATE = {
  templateList: [],
  templateDetails: {},
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case TYPES.templateList:
      return {
        ...state,
        templateList: action.payload,
      }

    case TYPES.templateDetails:
      return {
        ...state,
        templateDetails: action.payload,
      }

    default:
      return state;
  }
}
